// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"172":"63bcec687fadfad2","233":"327321b40594da66","304":"b3af562012a9d6b3","666":"b795a3c37cf07b5a"}[chunkId] + ".css";
};